import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs";
import ExerciseCategoryCreateForm from "./ui/ExerciseCategoryCreateForm";
import { useEffect, useState } from "react";
import { ExerciseCategory } from "../../../models";
import ExerciseCategoryService from "../../../services/ExerciseCategoryService";
import ExerciseCategoryEditForm from "./ui/ExerciseCategoryEditForm";
import NotFound from "../../../components/not-found";
import ExerciseCategorySkeleton from "./skeletons/ExerciseCategorySkeleton";

export default function ExerciseCategoryEditPage() {
const { id } = useParams<{ id: string }>();
  const [category, setCategory] = useState<ExerciseCategory | null>(null);
  const [loading, setLoading] = useState(true);
  const api = new ExerciseCategoryService();

  useEffect(() => {
    if (id) {
      api
        .getExerciseCategory(parseInt(id))
        .then((data) => {
          setCategory(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  }, [id]);

   if (!loading && !category) return <NotFound message="Category not found."></NotFound>;

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Exercise Categories", href: "/admin/exercise-categories" },
          { label: "Edit", href: `/admin/exercise-categories/edit/${id}`, active: true },
        ]}
      />   
      {loading ? (
        <ExerciseCategorySkeleton />
      ) : null}

      {!loading && category ? (
        <ExerciseCategoryEditForm category={category} />
      ):null}
   
    </main>
  );
}